"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-four/sections/testimonialSection.tsx */

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TestimonialSectionSlidersItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/patients/patient20.jpg" | "/Templates/Doccure/img/patients/patient22.jpg" | "/Templates/Doccure/img/patients/patient24.jpg" */
    src: string;
    /** Detected variants: "Every visit feels personal — the doctors remember our child’s history and genuinely care. The online booking remainder system make it so convenient for busy parents like us." | "My daughter used to be scared of doctor visits, but Dr. Emily made her feel completely at ease. She takes the time to explain everything to parents & gives practical advice." | "We struggled for months with my son’s breathing issues until we met Dr. Williams. She identified the problem right away and set up a treatment plan that’s worked beautifully" */
    p0Text: ReactNode;
    /** Detected variants: "Jessica Miller" | "Maria Lopez" | "Kevin Anderson" */
    p0P0Text: ReactNode;
    /** Detected variants: "Seattle, WA" | "Austin, TX" | "Chicago, IL" */
    p1Text: ReactNode;
    /** Detected variants: "slider-item" */
    className?: string;
    /** Detected variants: "testimonial-item-four" */
    div0ClassName?: string;
    /** Detected variants: "testimonial-author-img" */
    div0ClassName2?: string;
    /** Detected variants: "patient" */
    alt?: string;
    /** Detected variants: "rounded-circle" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "quote-icon" */
    div0ClassName3?: string;
    /** Detected variants: "quote" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "/Templates/Doccure/img/icons/quote-icon-02.svg" */
    imageWithBasePath0Src?: string;
    /** Detected variants: "testimonial-content" */
    div1ClassName?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
    /** Detected variants: "testimonial-author-info" */
    div2ClassName?: string;
    /** Detected variants: "author-name" */
    p0ClassName2?: string;
    /** Detected variants: "author-location" */
    p1ClassName?: string;
};
export type HomeFourTestimonialSectionGeneratedProps = {
    /** Default: "Our Reviews" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "What Parents Say" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "About Our Care" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Swiper0SwiperProps?: Partial<ComponentProps<typeof Swiper>>;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/testimonial-bg-01.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    swiperSlideSwiperSlideProps?: Partial<ComponentProps<typeof SwiperSlide>> | ((item: TestimonialSectionSlidersItem) => Partial<ComponentProps<typeof SwiperSlide>>);
    swiperSlideDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSectionSlidersItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    swiperSlideDiv0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSectionSlidersItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    testimonialSectionSliders: TestimonialSectionSlidersItem[];
    testimonialSectionSlidersItemWrapper?: (item: TestimonialSectionSlidersItem, content: ReactNode) => ReactNode;
    testimonialSectionSlidersRenderer?: (defaultNode: ReactNode) => ReactNode;
    testimonialSectionSlidersImageVisible?: boolean;
    testimonialSectionSlidersImageRenderer?: (item: TestimonialSectionSlidersItem, defaultNode: ReactNode) => ReactNode;
    testimonialSectionSlidersImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSectionSlidersItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    testimonialSectionSlidersSwiperSlideProps?: Partial<ComponentProps<typeof SwiperSlide>> | ((item: TestimonialSectionSlidersItem) => Partial<ComponentProps<typeof SwiperSlide>>);
};

const HomeFourTestimonialSectionGenerated: FC<HomeFourTestimonialSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Our Reviews",
    sectionDiv0Div0H20H2Text = "What Parents Say",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "About Our Care",
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/testimonial-bg-01.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionDiv0Swiper0SwiperProps,
    swiperSlideDiv0Div0ImageWithBasePath0ImageProps,
    swiperSlideDiv0Div1Div0ImageWithBasePath0ImageProps,
    swiperSlideSwiperSlideProps,
    testimonialSectionSliders,
    testimonialSectionSlidersItemWrapper,
    testimonialSectionSlidersRenderer,
    testimonialSectionSlidersImageVisible,
    testimonialSectionSlidersImageRenderer,
    testimonialSectionSlidersImageProps,
    testimonialSectionSlidersSwiperSlideProps,
}) => {
    return (
        <section className="testimonial-section-four section">
            <div className="container-fluid">
                <div className="section-header section-header-four text-center">
                    <div className="section-sub-title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <span>{sectionDiv0Div0H20Span0SpanText}</span>
                        </h2>
                    ))}
                </div>
                <Swiper loop={true} slidesPerView="auto" spaceBetween={30} loopAdditionalSlides={2} autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                }} breakpoints={{
                    0: {
                        slidesPerView: 1,
                        loop: false
                    },
                    768: {
                        slidesPerView: 1,
                        loop: false
                    },
                    992: {
                        slidesPerView: 2,
                        loop: true,
                        loopAdditionalSlides: 1
                    }
                }} className="testimonial-slider-four" {...(sectionDiv0Swiper0SwiperProps ?? {})}>
                    {renderCollectionNode(
                        testimonialSectionSliders,
                        (item: TestimonialSectionSlidersItem) => (
                            <SwiperSlide className={item.className ?? "slider-item"} {...(typeof testimonialSectionSlidersSwiperSlideProps === "function" ? testimonialSectionSlidersSwiperSlideProps(item) : (testimonialSectionSlidersSwiperSlideProps ?? {}))} {...(typeof swiperSlideSwiperSlideProps === "function" ? swiperSlideSwiperSlideProps(item) : (swiperSlideSwiperSlideProps ?? {}))} key={item.key}>
                                <div className={item.div0ClassName ?? "testimonial-item-four"}>
                                    <div className={item.div0ClassName2 ?? "testimonial-author-img"}>
                                        {renderItemNode(testimonialSectionSlidersImageVisible, testimonialSectionSlidersImageRenderer, item, (
                                            <SmartImage src={item.src} className={item.imageWithBasePath0ClassName ?? "rounded-circle"} alt={item.alt ?? "patient"} {...(typeof testimonialSectionSlidersImageProps === "function" ? testimonialSectionSlidersImageProps(item) : (testimonialSectionSlidersImageProps ?? {}))} {...(typeof swiperSlideDiv0Div0ImageWithBasePath0ImageProps === "function" ? swiperSlideDiv0Div0ImageWithBasePath0ImageProps(item) : (swiperSlideDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                    <div>
                                        <div className={item.div0ClassName3 ?? "quote-icon"}>
                                            {renderItemNode(testimonialSectionSlidersImageVisible, testimonialSectionSlidersImageRenderer, item, (
                                                <SmartImage src={item.imageWithBasePath0Src ?? "/Templates/Doccure/img/icons/quote-icon-02.svg"} alt={item.imageWithBasePath0Alt ?? "quote"} {...(typeof testimonialSectionSlidersImageProps === "function" ? testimonialSectionSlidersImageProps(item) : (testimonialSectionSlidersImageProps ?? {}))} {...(typeof swiperSlideDiv0Div1Div0ImageWithBasePath0ImageProps === "function" ? swiperSlideDiv0Div1Div0ImageWithBasePath0ImageProps(item) : (swiperSlideDiv0Div1Div0ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </div>
                                        <div className={item.div1ClassName ?? "testimonial-content"}>
                                            <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                        </div>
                                        <div className={item.div2ClassName ?? "testimonial-author-info"}>
                                            <p className={item.p0ClassName2 ?? "author-name"}>{item.p0P0Text}</p>
                                            <p className={item.p1ClassName ?? "author-location"}>{item.p1Text}</p>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ),
                        testimonialSectionSlidersItemWrapper,
                        testimonialSectionSlidersRenderer
                    )}
                </Swiper>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="testimonial-bg" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeFourTestimonialSectionGenerated;
